// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.overlay {
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  width: 27vh;
  height: 50vh;
  background: white;
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  z-index: 9999;
}
.overlay--settings {
  height: 52vh;
}
.overlay__container {
  width: 100%;
  border-radius: 8px;
  overflow: hidden;
  position: relative;
  height: 100%;
}
.overlay__container .chip {
  background: #e3e0ff;
  color: black;
}
.overlay:before {
  content: "";
  position: absolute;
  top: -8px;
  right: 16px;
  width: 16px;
  height: 16px;
  background: white;
  transform: rotate(45deg);
  box-shadow: -2px -2px 5px rgba(0, 0, 0, 0.05);
}
.overlay__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  border-bottom: 1px solid #e5e7eb;
}
.overlay__header h2 {
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
}
.overlay__header button {
  padding: 4px;
  border-radius: 50%;
  transition: all 0.2s;
}
.overlay__header button:hover {
  background: #f3f4f6;
}
.overlay__header button svg {
  width: 16px;
  height: 16px;
  color: #666;
}
.overlay__list {
  max-height: calc(47vh - 70px);
  overflow-y: auto;
  padding: 0 8px;
}
.overlay__list::-webkit-scrollbar {
  width: 4px;
}
.overlay__list::-webkit-scrollbar-track {
  background: #f1f1f1;
}
.overlay__list::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 4px;
}
.overlay__list-item {
  padding: 14px 12px;
  border-bottom: 1px solid #e5e7eb;
  transition: background 0.2s;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}
.overlay__list-item:last-child {
  border-bottom: none;
}
.overlay__list-item:hover {
  background: #f9fafb;
}
.overlay__list-item-header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 6px;
}
.overlay__list-item-header svg {
  width: 16px;
  height: 16px;
  color: #666;
  flex-shrink: 0;
}
.overlay__list-item-header span {
  font-size: 14px;
  font-weight: 500;
  word-break: break-word;
}
.overlay__list-item-content {
  margin-left: 26px;
  font-size: 14px;
  color: #666;
  word-break: break-word;
}
.overlay__settings {
  padding: 12px 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  max-height: calc(52vh - 80px);
  overflow-y: auto;
}
.overlay__settings .p-inputswitch-slider {
  background: #4F4BFF;
}
.overlay__settings .p-button {
  background: #4F4BFF;
  color: white;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
}
.overlay__settings label {
  display: block;
  font-size: 14px;
  color: #666;
  margin-bottom: 10px;
}
.overlay__settings .field {
  margin-bottom: 8px;
}
.overlay__settings .field-input {
  width: 100%;
  padding: 8px;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  font-size: 14px;
  transition: all 0.2s;
}
.overlay__settings .field-input:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.1);
}
.overlay__settings .field-input.small {
  width: 20%;
  min-width: 60px;
}
.overlay__settings-notification {
  margin-top: 8px;
}
.overlay__settings-notification p {
  font-size: 14px;
  color: #666;
  margin-bottom: 12px;
}
.overlay__settings .toggle {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 8px;
}
.overlay__settings .toggle-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.overlay__settings .toggle-header .section-title {
  font-size: 12px;
  color: #000000;
  margin: 0;
}
.overlay__settings .toggle-header :global(.p-inputswitch).p-inputswitch-checked {
  background: #4F4BFF;
}
.overlay__settings .toggle-header :global(.p-inputswitch).p-inputswitch-checked .p-inputswitch-slider {
  background: #4F4BFF;
}
.overlay__settings .toggle-content {
  display: flex;
  align-items: center;
  gap: 8px;
}
.overlay__settings .toggle-content .field-input {
  width: 20%;
  min-width: 60px;
}
.overlay__settings .toggle-content span {
  font-size: 14px;
  color: #000000;
}
.overlay__settings-save {
  width: 100%;
  padding: 8px;
  background: #4F4BFF;
  color: white;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  transition: background 0.2s;
}
.overlay__settings-save:hover {
  background: rgb(29.1333333333, 24, 255);
}
.overlay__settings::-webkit-scrollbar {
  width: 4px;
}
.overlay__settings::-webkit-scrollbar-track {
  background: #f1f1f1;
}
.overlay__settings::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 4px;
}
.overlay__settings .separator {
  width: 100%;
  height: 1px;
  background: #e5e7eb;
  margin: 16px 0;
}
.overlay__settings .separator.thin {
  margin: 8px 0;
  opacity: 0.5;
}
.overlay .slide-container {
  position: absolute;
  width: 200%;
  height: 100%;
  display: flex;
  transition: transform 0.3s ease-in-out;
}
.overlay .slide-container.show-settings {
  transform: translateX(-50%);
}
.overlay .main-view,
.overlay .settings-view {
  width: 50%;
  height: 100%;
  flex-shrink: 0;
}`, "",{"version":3,"sources":["webpack://./src/features/profile/components/withdrawal-overlay/withdrawal-overlay.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;EACA,qBAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,0CAAA;EACA,aAAA;AACJ;AACI;EACE,YAAA;AACN;AAEI;EACE,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,YAAA;AAAN;AAEM;EACE,mBAAA;EACA,YAAA;AAAR;AAII;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,wBAAA;EACA,6CAAA;AAFN;AAKI;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;EACA,gCAAA;AAHN;AAKM;EACE,eAAA;EACA,gBAAA;EACA,eAAA;AAHR;AAMM;EACE,YAAA;EACA,kBAAA;EACA,oBAAA;AAJR;AAMQ;EACE,mBAAA;AAJV;AAOQ;EACE,WAAA;EACA,YAAA;EACA,WAAA;AALV;AAUI;EACE,6BAAA;EACA,gBAAA;EACA,cAAA;AARN;AAUM;EACE,UAAA;AARR;AAWM;EACE,mBAAA;AATR;AAYM;EACE,gBAAA;EACA,kBAAA;AAVR;AAaM;EACE,kBAAA;EACA,gCAAA;EACA,2BAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;AAXR;AAYQ;EACE,mBAAA;AAVV;AAaQ;EACE,mBAAA;AAXV;AAcQ;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;AAZV;AAcU;EACE,WAAA;EACA,YAAA;EACA,WAAA;EACA,cAAA;AAZZ;AAeU;EACE,eAAA;EACA,gBAAA;EACA,sBAAA;AAbZ;AAiBQ;EACE,iBAAA;EACA,eAAA;EACA,WAAA;EACA,sBAAA;AAfV;AAoBI;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,6BAAA;EACA,gBAAA;AAlBN;AAmBM;EACM,mBAAA;AAjBZ;AAmBM;EACE,mBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;AAjBR;AAmBM;EACE,cAAA;EACA,eAAA;EACA,WAAA;EACA,mBAAA;AAjBR;AAoBM;EACE,kBAAA;AAlBR;AAqBM;EACE,WAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,oBAAA;AAnBR;AAqBQ;EACE,aAAA;EACA,qBAAA;EACA,6CAAA;AAnBV;AAsBQ;EACE,UAAA;EACA,eAAA;AApBV;AAwBM;EACE,eAAA;AAtBR;AAwBQ;EACE,eAAA;EACA,WAAA;EACA,mBAAA;AAtBV;AA0BM;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,kBAAA;AAxBR;AA0BQ;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;AAxBV;AA0BU;EACE,eAAA;EACA,cAAA;EACA,SAAA;AAxBZ;AA4BY;EACE,mBAAA;AA1Bd;AA4Bc;EACE,mBAAA;AA1BhB;AAgCQ;EAEE,aAAA;EACA,mBAAA;EACA,QAAA;AA/BV;AAiCU;EACE,UAAA;EACA,eAAA;AA/BZ;AAkCU;EACE,eAAA;EACA,cAAA;AAhCZ;AAqCM;EAEE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,2BAAA;AApCR;AAsCQ;EACE,uCAAA;AApCV;AAwCM;EACE,UAAA;AAtCR;AAyCM;EACE,mBAAA;AAvCR;AA0CM;EACE,gBAAA;EACA,kBAAA;AAxCR;AA2CM;EACE,WAAA;EACA,WAAA;EACA,mBAAA;EACA,cAAA;AAzCR;AA2CQ;EACE,aAAA;EACA,YAAA;AAzCV;AA8CI;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,sCAAA;AA5CN;AA8CM;EACE,2BAAA;AA5CR;AAgDI;;EAEE,UAAA;EACA,YAAA;EACA,cAAA;AA9CN","sourcesContent":[".overlay {\n    position: absolute;\n    top: calc(100% + 8px);\n    right: 0;\n    width: 27vh;\n    height: 50vh;\n    background: white;\n    border-radius: 8px;\n    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);\n    z-index: 9999;\n    \n    &--settings {\n      height: 52vh;\n    }\n\n    &__container {\n      width: 100%;\n      border-radius: 8px;\n      overflow: hidden;\n      position: relative;\n      height: 100%;\n\n      .chip{\n        background: #E3E0FFFF;\n        color: black;\n      }\n    }\n\n    &:before {\n      content: '';\n      position: absolute;\n      top: -8px;\n      right: 16px;\n      width: 16px;\n      height: 16px;\n      background: white;\n      transform: rotate(45deg);\n      box-shadow: -2px -2px 5px rgba(0, 0, 0, 0.05);\n    }\n  \n    &__header {\n      display: flex;\n      align-items: center;\n      justify-content: space-between;\n      padding: 12px 16px;\n      border-bottom: 1px solid #e5e7eb;\n      \n      h2 {\n        font-size: 14px;\n        font-weight: 600;\n        cursor: pointer;\n      }\n  \n      button {\n        padding: 4px;\n        border-radius: 50%;\n        transition: all 0.2s;\n  \n        &:hover {\n          background: #f3f4f6;\n        }\n        \n        svg {\n          width: 16px;\n          height: 16px;\n          color: #666;\n        }\n      }\n    }\n  \n    &__list {\n      max-height: calc(47vh - 70px);\n      overflow-y: auto;\n      padding: 0 8px;\n      \n      &::-webkit-scrollbar {\n        width: 4px;\n      }\n      \n      &::-webkit-scrollbar-track {\n        background: #f1f1f1;\n      }\n      \n      &::-webkit-scrollbar-thumb {\n        background: #888;\n        border-radius: 4px;\n      }\n      \n      &-item {\n        padding: 14px 12px;\n        border-bottom: 1px solid #e5e7eb;\n        transition: background 0.2s;\n        display: flex;\n        flex-direction: column;\n        gap: 0.5rem;\n        &:last-child {\n          border-bottom: none;\n        }\n  \n        &:hover {\n          background: #f9fafb;\n        }\n  \n        &-header {\n          display: flex;\n          align-items: center;\n          gap: 10px;\n          margin-bottom: 6px;\n  \n          svg {\n            width: 16px;\n            height: 16px;\n            color: #666;\n            flex-shrink: 0;\n          }\n  \n          span {\n            font-size: 14px;\n            font-weight: 500;\n            word-break: break-word;\n          }\n        }\n  \n        &-content {\n          margin-left: 26px;\n          font-size: 14px;\n          color: #666;\n          word-break: break-word;\n        }\n      }\n    }\n  \n    &__settings {\n      padding: 12px 16px;\n      display: flex;\n      flex-direction: column;\n      gap: 16px;\n      max-height: calc(52vh - 80px);\n      overflow-y: auto;\n      .p-inputswitch-slider{\n            background: #4F4BFF;  \n        }\n      .p-button {\n        background: #4F4BFF;\n        color: white;\n        border-radius: 6px;\n        font-size: 14px;\n        font-weight: 500;\n      }\n      label {\n        display: block;\n        font-size: 14px;\n        color: #666;\n        margin-bottom: 10px;\n      }\n  \n      .field {\n        margin-bottom: 8px;\n      }\n  \n      .field-input {\n        width: 100%;\n        padding: 8px;\n        border: 1px solid #e5e7eb;\n        border-radius: 6px;\n        font-size: 14px;\n        transition: all 0.2s;\n  \n        &:focus {\n          outline: none;\n          border-color: #3b82f6;\n          box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.1);\n        }\n  \n        &.small {\n          width: 20%;\n          min-width: 60px;\n        }\n      }\n  \n      &-notification {\n        margin-top: 8px;\n  \n        p {\n          font-size: 14px;\n          color: #666;\n          margin-bottom: 12px;\n        }\n      }\n  \n      .toggle {\n        display: flex;\n        flex-direction: column;\n        gap: 8px;\n        margin-bottom: 8px;\n  \n        &-header {\n          display: flex;\n          align-items: center;\n          justify-content: space-between;\n  \n          .section-title {\n            font-size: 12px;\n            color: #000000;\n            margin: 0;\n          }\n\n          :global(.p-inputswitch) {\n            &.p-inputswitch-checked {\n              background: #4F4BFF;\n\n              .p-inputswitch-slider {\n                background: #4F4BFF;\n              }\n            }\n          }\n        }\n  \n        &-content {\n            \n          display: flex;\n          align-items: center;\n          gap: 8px;\n  \n          .field-input {\n            width: 20%;\n            min-width: 60px;\n          }\n  \n          span {\n            font-size: 14px;\n            color: #000000;\n          }\n        }\n      }\n  \n      &-save {\n        \n        width: 100%;\n        padding: 8px;\n        background: #4F4BFF;\n        color: white;\n        border-radius: 6px;\n        font-size: 14px;\n        font-weight: 500;\n        transition: background 0.2s;\n  \n        &:hover {\n          background: darken(#4F4BFF, 10%);\n        }\n      }\n      \n      &::-webkit-scrollbar {\n        width: 4px;\n      }\n      \n      &::-webkit-scrollbar-track {\n        background: #f1f1f1;\n      }\n      \n      &::-webkit-scrollbar-thumb {\n        background: #888;\n        border-radius: 4px;\n      }\n\n      .separator {\n        width: 100%;\n        height: 1px;\n        background: #e5e7eb;\n        margin: 16px 0;\n\n        &.thin {\n          margin: 8px 0;\n          opacity: 0.5;\n        }\n      }\n    }\n\n    .slide-container {\n      position: absolute;\n      width: 200%;\n      height: 100%;\n      display: flex;\n      transition: transform 0.3s ease-in-out;\n\n      &.show-settings {\n        transform: translateX(-50%);\n      }\n    }\n\n    .main-view,\n    .settings-view {\n      width: 50%;\n      height: 100%;\n      flex-shrink: 0;\n    }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
